import { GlobalID } from "@/relay/RelayTypes"
import Relay from "@/relay/relayUtils"
import { displayErrorToast, displaySuccessToast } from "@components/toast/ToastProvider"
import { DiscoButtonSkeleton } from "@disco-ui"
import {
  OverridableDiscoButton,
  OverridableDiscoButtonChildren,
} from "@disco-ui/button/OverridableDiscoButton"
import { TestIDProps } from "@utils/typeUtils"
import { graphql, useMutation } from "react-relay"
import { RecrawlTrainingSourceButtonMutation } from "./__generated__/RecrawlTrainingSourceButtonMutation.graphql"

interface RecrawlTrainingSourceButtonProps extends TestIDProps {
  trainingSourceId: GlobalID
  children: OverridableDiscoButtonChildren
}

function RecrawlTrainingSourceButton({
  trainingSourceId,
  testid = "RecrawlTrainingSourceButton",
  children = "Recrawl",
}: RecrawlTrainingSourceButtonProps) {
  const [commit, isRefreshing] = useMutation<RecrawlTrainingSourceButtonMutation>(graphql`
    mutation RecrawlTrainingSourceButtonMutation($input: RefreshTrainingSourceInput!) {
      response: refreshTrainingSource(input: $input) {
        node {
          ...TrainingSourceListItemFragment
        }
        errors {
          field
          message
        }
      }
    }
  `)
  return (
    <OverridableDiscoButton
      testid={testid}
      onClick={refreshTrainingSource}
      disabled={isRefreshing}
      shouldDisplaySpinner={isRefreshing}
    >
      {children}
    </OverridableDiscoButton>
  )

  function refreshTrainingSource(e: React.MouseEvent) {
    e.preventDefault()
    commit({
      variables: {
        input: {
          id: trainingSourceId,
        },
      },
      onCompleted({ response }) {
        if (response.errors) {
          return displayErrorToast({ message: response.errors[0].message })
        }
        displaySuccessToast({ message: "Your links will be updated shortly." })
      },
      onError(error) {
        console.error(error)
        displayErrorToast({
          message: "An unexpected error occurred, please try again later.",
        })
      },
    })
  }
}

export default Relay.withSkeleton({
  skeleton: () => <DiscoButtonSkeleton width={"100%"} />,
  component: RecrawlTrainingSourceButton,
})
